import advanceReportingConstants from "@/constants/advanceReportingConstants"

const pages = {
  mainPage() {
    return {
      name: "Advanced Reporting",
      i18n_name_key: "sidebar_items.advanced_reporting",
      path: advanceReportingConstants.PATHS.REPORT,
      roles: advanceReportingConstants.ADVANCE_REPORTING_ADMIN_ROLES,
      helpKey: "advance_reporting_overview_v0004",
      dependency: "routerDependencies/hasAdvanceReportingAccess"
    }
  },
  scheduledReportsPage() {
    return {
      name: "Scheduled Reports",
      i18n_name_key: "sidebar_items.scheduled_reports",
      path: advanceReportingConstants.PATHS.SCHEDULED_REPORTS,
      roles: advanceReportingConstants.ADVANCE_REPORTING_ADMIN_ROLES,
      helpKey: "advance_reporting_scheduled_reports_v0002",
      dependency: "routerDependencies/hasAdvanceReportingAccess"
    }
  }
}

export default {
  pages
}
